import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../store'
import { fetchVoiceBots } from '../redux/voice-bots/slice'
import { fetchChatBots } from '../redux/chat-bots/slice'
import { fetchPhoneNumbers } from '../redux/phone-numbers/slice'
import { fetchMegaComposers, fetchSplitComposers } from '../redux/prompts/slice'
import { fetchSessionWebhooks, fetchStateFields } from '../redux/payloads/slice'
import { Vertical } from 'interfaces/users'
import { fetchInboundRoutes } from 'lib/redux/routes/slice'
import { TRELLUS_TEAM_ID } from '../../cfg/const'

export function useBotInfo() {
  const dispatch = useDispatch<AppDispatch>()
  const team = useSelector((state: RootState) => state.team.value)
  
  useEffect(() => {
    if (team?.team_id && (team.team_id === TRELLUS_TEAM_ID || team.vertical === Vertical.LEGAL_INTAKE)) {
      dispatch(fetchInboundRoutes())
      dispatch(fetchMegaComposers())
      dispatch(fetchSplitComposers())
      dispatch(fetchVoiceBots())
      dispatch(fetchChatBots())
      dispatch(fetchStateFields())
      dispatch(fetchSessionWebhooks())
      dispatch(fetchPhoneNumbers())
    }
  }, [team?.team_id, dispatch])
}